import { FC } from 'react';

import UiCounter, { CounterPropsTypes } from '@uikit/counter';

import { Wrapper, DescContent, Title, Label, CounterContent } from './styled';

interface IGuestSelection {
  title: string;
  label: string;
  counterProps: CounterPropsTypes;
}

const GuestSelection: FC<IGuestSelection> = ({
  title,
  label,
  counterProps,
}) => {
  return (
    <Wrapper>
      <DescContent>
        <Title>{title}</Title>
        <Label>{label}</Label>
      </DescContent>
      <CounterContent>
        <UiCounter {...counterProps} />
      </CounterContent>
    </Wrapper>
  );
};

export default GuestSelection;
